import { createContext } from 'react';

type UseIconContext = {
  sprite: string;
};

const IconContext = createContext<UseIconContext>({} as UseIconContext);

type IconProviderProps = {
  children: React.ReactNode;
  sprite: string;
};

/**
 * Supplies the icon sprite URL to every {@link Icon} rendered beneath it. Mount
 * it once near the app root with the `sprite` your build emits; each `Icon` then
 * resolves its symbol from that sheet through context. Standalone setup you wire
 * yourself — not a part composed inside `Icon`.
 *
 * @category icons
 */
const IconProvider = ({ children, sprite }: IconProviderProps) => {
  return (
    <IconContext.Provider value={{ sprite }}>{children}</IconContext.Provider>
  );
};

export { IconContext, IconProvider };
